import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bomService } from '../services/api';

const POR_PAGINA = 12;

export default function ListaBOM() {
  const [ensambles, setEnsambles] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState('');
  const [syncing, setSyncing]     = useState(false);
  const [error, setError]         = useState(null);
  const [pagina, setPagina]       = useState(1);
  const navigate = useNavigate();

  const cargar = async (q = '') => {
    setLoading(true); setError(null);
    try {
      const { data } = await bomService.getAll(q);
      setEnsambles(data.data || []);
      setPagina(1);
    } catch {
      setError('No se pudo conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    clearTimeout(window._st);
    window._st = setTimeout(() => cargar(val), 400);
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      await bomService.syncManual();
      setTimeout(() => { cargar(); setSyncing(false); }, 3000);
    } catch { setSyncing(false); }
  };

  const totalPaginas = Math.ceil(ensambles.length / POR_PAGINA);
  const inicio       = (pagina - 1) * POR_PAGINA;
  const paginados    = ensambles.slice(inicio, inicio + POR_PAGINA);

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:800, color:'#6A2C75', letterSpacing:0.3 }}>Lista de Materiales</h1>
          <p style={{ color:'#7a6882', fontSize:13, marginTop:4 }}>
            {ensambles.length} ensambles activos · Página {pagina} de {totalPaginas || 1}
          </p>
        </div>
        <button onClick={handleSync} disabled={syncing} style={{
          background: syncing ? '#BBA4C0' : '#6A2C75', color:'#fff', border:'none',
          borderRadius:8, padding:'10px 20px', cursor: syncing ? 'default' : 'pointer',
          fontSize:13, fontWeight:700, display:'flex', alignItems:'center', gap:8,
          boxShadow: syncing ? 'none' : '0 2px 8px rgba(106,44,117,0.3)',
        }}>
          {syncing ? '⏳ Sincronizando...' : '🔄 Sincronizar NetSuite'}
        </button>
      </div>

      {/* Buscador */}
      <div style={{ position:'relative', marginBottom:20 }}>
        <span style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', color:'#BBA4C0', fontSize:16 }}>🔍</span>
        <input
          type="text" placeholder="Buscar por nombre o código..."
          value={search} onChange={handleSearch}
          style={{
            width:'100%', padding:'11px 16px 11px 40px', borderRadius:10,
            border:'1.5px solid #e0d5e8', fontSize:14, outline:'none', background:'#fff',
            boxShadow:'0 1px 6px rgba(106,44,117,0.06)', transition:'border-color 0.2s',
          }}
          onFocus={e => e.target.style.borderColor = '#6A2C75'}
          onBlur={e => e.target.style.borderColor = '#e0d5e8'}
        />
      </div>

      {error && (
        <div style={{ background:'#fdecea', color:'#c62828', padding:'12px 16px', borderRadius:8, marginBottom:16, fontSize:13, borderLeft:'3px solid #c62828' }}>
          ❌ {error}
        </div>
      )}

      {/* Grid de cards */}
      {loading ? (
        <div style={{ textAlign:'center', padding:60, color:'#BBA4C0' }}>
          <div style={{ fontSize:32, marginBottom:12 }}>⏳</div>
          Cargando ensambles...
        </div>
      ) : ensambles.length === 0 ? (
        <div style={{ textAlign:'center', padding:60, color:'#BBA4C0' }}>
          <div style={{ fontSize:32, marginBottom:12 }}>🔍</div>
          No se encontraron ensambles
        </div>
      ) : (
        <>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:14, marginBottom:24 }}>
            {paginados.map(e => (
              <div
                key={e.id_netsuite}
                onClick={() => navigate(`/bom/${e.id_netsuite}`)}
                style={{
                  background:'#fff', borderRadius:12, padding:'18px 20px',
                  border:'1.5px solid #e0d5e8', cursor:'pointer',
                  transition:'all 0.15s', position:'relative', overflow:'hidden',
                }}
                onMouseEnter={el => {
                  el.currentTarget.style.borderColor = '#6A2C75';
                  el.currentTarget.style.boxShadow = '0 4px 20px rgba(106,44,117,0.12)';
                  el.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={el => {
                  el.currentTarget.style.borderColor = '#e0d5e8';
                  el.currentTarget.style.boxShadow = 'none';
                  el.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                {/* Acento superior */}
                <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:'linear-gradient(90deg, #6A2C75, #D6A644)' }} />

                <div style={{ marginTop:4 }}>
                  <div style={{ fontWeight:700, fontSize:15, color:'#2a1a2e', marginBottom:4, lineHeight:1.3 }}>
                    {e.nombre || e.codigo || `Ensamble #${e.id_netsuite}`}
                  </div>
                  {e.codigo && e.codigo !== e.nombre && (
                    <div style={{ fontSize:11, color:'#BBA4C0', fontWeight:600, letterSpacing:0.5, marginBottom:8 }}>
                      {e.codigo}
                    </div>
                  )}
                </div>

                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:12 }}>
                  <span style={{ fontSize:11, color:'#7a6882', background:'#f5f3f0', borderRadius:6, padding:'3px 8px' }}>
                    {e.clase || 'Sin clasificación'}
                  </span>
                  <span style={{ background:'#f5f0fa', color:'#6A2C75', borderRadius:20, padding:'3px 12px', fontSize:12, fontWeight:700 }}>
                    {e.total_componentes} comp.
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Paginación */}
          {totalPaginas > 1 && (
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center', gap:8 }}>
              <button
                onClick={() => setPagina(p => Math.max(1, p - 1))}
                disabled={pagina === 1}
                style={{ padding:'8px 16px', borderRadius:8, border:'1.5px solid #e0d5e8', background: pagina === 1 ? '#f5f3f0' : '#fff', color: pagina === 1 ? '#BBA4C0' : '#6A2C75', cursor: pagina === 1 ? 'default' : 'pointer', fontWeight:700, fontSize:13 }}
              >
                ← Anterior
              </button>

              {Array.from({ length: totalPaginas }, (_, i) => i + 1)
                .filter(n => n === 1 || n === totalPaginas || Math.abs(n - pagina) <= 1)
                .reduce((acc, n, i, arr) => {
                  if (i > 0 && n - arr[i-1] > 1) acc.push('...');
                  acc.push(n);
                  return acc;
                }, [])
                .map((n, i) => n === '...' ? (
                  <span key={`dots-${i}`} style={{ color:'#BBA4C0', padding:'0 4px' }}>•••</span>
                ) : (
                  <button key={n} onClick={() => setPagina(n)} style={{
                    width:36, height:36, borderRadius:8, border:'1.5px solid',
                    borderColor: n === pagina ? '#6A2C75' : '#e0d5e8',
                    background: n === pagina ? '#6A2C75' : '#fff',
                    color: n === pagina ? '#fff' : '#6A2C75',
                    cursor:'pointer', fontWeight:700, fontSize:13,
                  }}>
                    {n}
                  </button>
                ))
              }

              <button
                onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))}
                disabled={pagina === totalPaginas}
                style={{ padding:'8px 16px', borderRadius:8, border:'1.5px solid #e0d5e8', background: pagina === totalPaginas ? '#f5f3f0' : '#fff', color: pagina === totalPaginas ? '#BBA4C0' : '#6A2C75', cursor: pagina === totalPaginas ? 'default' : 'pointer', fontWeight:700, fontSize:13 }}
              >
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}